import React, { Component } from "react";
import config from "../../config.json";
import httpService from "../../services/httpService";
import { Table } from "react-bootstrap";

class EReceptLog extends Component {
  state = {};

  componentDidMount = () => {
    this.nactiLog();
  };

  componentDidUpdate = () => {
    const { rand, recept_id } = this.state;
    if (
      (rand && recept_id && rand !== this.props.rand) ||
      recept_id !== this.props.recept_id
    ) {
      this.nactiLog();
    }
  };

  nactiLog = async () => {
    const { rand, recept_id } = this.props;
    const log = await httpService.post(config.apiEndpoint + "erecept/log.php", {
      recept_id
    });
    this.setState({ log: log.data.log, rand, recept_id, loaded: true });
  };

  render() {
    const { loaded, log } = this.state;
    return (
      <React.Fragment>
        {loaded &&
          (log && log.length > 0 ? (
            <Table striped bordered hover style={{ fontSize: "0.7em" }}>
              <thead>
                <tr>
                  <th>Datum</th>
                  <th>Příjemce</th>
                  <th>Zpráva</th>
                </tr>
              </thead>
              <tbody>
                {log.map(l => (
                  <tr key={l.message_id}>
                    <td>
                      {l.datum}
                      <div>
                        <div className="badge badge-info">{l.typ_zpravy}</div>
                      </div>
                    </td>
                    <td>
                      {l.prijemce}
                      {l.odesilatel && l.odesilatel !== "" && (
                        <span style={{ display: "block" }}>
                          ({l.odesilatel})
                        </span>
                      )}
                    </td>
                    <td>
                      {l.predmet && l.predmet !== "" && (
                        <div>
                          <strong>{l.predmet}</strong>
                        </div>
                      )}
                      {l.zprava}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="alert alert-danger">Nic tu není...</div>
          ))}
      </React.Fragment>
    );
  }
}

export default EReceptLog;
